var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0007 3.20837C8.04058 3.20837 3.20898 8.03997 3.20898 14C3.20898 19.9601 8.04058 24.7917 14.0007 24.7917C19.9607 24.7917 24.7923 19.9601 24.7923 14C24.7923 8.03997 19.9607 3.20837 14.0007 3.20837ZM1.45898 14C1.45898 7.07347 7.07408 1.45837 14.0007 1.45837C20.9273 1.45837 26.5423 7.07347 26.5423 14C26.5423 20.9267 20.9273 26.5417 14.0007 26.5417C7.07408 26.5417 1.45898 20.9267 1.45898 14ZM9.97961 19.1305C11.1141 18.2895 12.5015 17.7917 14.0007 17.7917C15.4998 17.7917 16.8872 18.2895 18.0217 19.1305C18.41 19.4182 18.4914 19.9661 18.2036 20.3544C17.9159 20.7427 17.3679 20.8241 16.9796 20.5363C16.1298 19.9065 15.1042 19.5417 14.0007 19.5417C12.8971 19.5417 11.8715 19.9065 11.0217 20.5363C10.6335 20.8241 10.0855 20.7427 9.7977 20.3544C9.50994 19.9661 9.59137 19.4182 9.97961 19.1305Z",
    fill: "#D20A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6673 12.25C18.6673 13.2165 18.145 14 17.5007 14C16.8563 14 16.334 13.2165 16.334 12.25C16.334 11.2835 16.8563 10.5 17.5007 10.5C18.145 10.5 18.6673 11.2835 18.6673 12.25Z",
    fill: "#D20A0A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6673 12.25C11.6673 13.2165 11.145 14 10.5007 14C9.85632 14 9.33398 13.2165 9.33398 12.25C9.33398 11.2835 9.85632 10.5 10.5007 10.5C11.145 10.5 11.6673 11.2835 11.6673 12.25Z",
    fill: "#D20A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFace);
export default __webpack_public_path__ + "static/media/sad-face.5239e93a011d758a11cfe3770072773a.svg";
export { ForwardRef as ReactComponent };